module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "prodSettBG"
    }
  }, [_c('div', {
    staticClass: "ui container",
    attrs: {
      "id": "prodSetP"
    }
  }, [_c('p', [_vm._v(" ")]), _vm._v(" "), _c('h1', {
    staticClass: "ui inverted grey header",
    staticStyle: {
      "position": "relative",
      "text-shadow": "#333 1px 2px 3px"
    }
  }, [_c('i', {
    staticClass: "cubes icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n      Product Tracking Settings\n    ")]), _vm._v(" "), (_vm.$root.anySellerAccountSetupCompleted) ? _c('button', {
    staticClass: "small ui compact button",
    staticStyle: {
      "position": "absolute",
      "right": "0px",
      "top": "12px"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push(_vm.$root.defaultPath)
      }
    }
  }, [_c('i', {
    staticClass: "left chevron icon"
  }), _vm._v("Back")]) : _vm._e()]), _vm._v(" "), (_vm.loadingdata) ? _c('div', {
    staticClass: "sentrk_s",
    staticStyle: {
      "margin": "150px auto"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.loadError && !_vm.loadingdata) ? _c('div', {
    staticClass: "ui negative message"
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("Could not load product tracking settings")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.loadError))]), _vm._v(" "), _c('button', {
    staticClass: "ui button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.fetchProductTrackingSettings
    }
  }, [_vm._v("Retry")])]) : _vm._e(), _vm._v(" "), (!_vm.$root.anySellerAccountSetupCompleted) ? _c('div', {
    staticClass: "ui info  message"
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("\n      First time here?\n    ")]), _vm._v(" "), _vm._m(0)]) : _vm._e(), _vm._v(" "), (!_vm.$root.anySellerAccountSetupCompleted) ? _c('div', {
    staticClass: "ui info  message"
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("\n      About these marketplaces\n    ")]), _vm._v(" "), _vm._m(1)]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loadingdata && !_vm.loadError),
      expression: "!loadingdata && !loadError"
    }],
    staticClass: "ui attached segment"
  }, [_c('div', {
    staticStyle: {
      "min-height": "40px"
    }
  }, [_c('div', {
    staticClass: "ui input left floated menu"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterText),
      expression: "filterText"
    }, {
      name: "prevent-autofill",
      rawName: "v-prevent-autofill",
      value: (_vm.filterText),
      expression: "filterText"
    }],
    attrs: {
      "type": "search",
      "placeholder": "Filter by ASIN, Title or Short-Hand Name",
      "size": "40"
    },
    domProps: {
      "value": (_vm.filterText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filterText = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.maxPage > 0) ? _c('pagination', {
    attrs: {
      "currentPage": _vm.currentPage,
      "maxPage": _vm.maxPage,
      "currentPageRequested": _vm.currentPageRequested
    },
    on: {
      "back-to-1": function($event) {
        _vm.currentPageRequested = 0
      },
      "back": function($event) {
        _vm.currentPageRequested = Math.max(0, _vm.currentPage - 1)
      },
      "forward": function($event) {
        _vm.currentPageRequested = Math.min(_vm.maxPage, _vm.currentPage + 1)
      },
      "forward-all-the-way": function($event) {
        _vm.currentPageRequested = _vm.maxPage
      }
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _vm._l((_vm.deepVisible), function(acc) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.loadingdata && !_vm.loadError),
        expression: "!loadingdata && !loadError"
      }],
      key: acc.sellerId,
      staticClass: "ui attached segment"
    }, [_c('h4', [_vm._v("Account " + _vm._s(acc.name))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('table', {
      class: 'ui very basic ' + (acc.products == null ? 'blurring dimmable ' : '') + 'table'
    }, [_vm._m(2, true), _vm._v(" "), _vm._m(3, true), _vm._v(" "), (acc.products != null && acc.products.length > 0) ? _c('tbody', _vm._l((acc.products), function(p) {
      return _c('product-row', {
        key: p.productId,
        attrs: {
          "product": p,
          "automaticallyTrackNewProducts": _vm.automaticallyTrackNewProducts
        },
        on: {
          "shortName-changed": function($event) {
            return _vm.onShortNameChange($event)
          },
          "show-changed": function($event) {
            return _vm.onShowChange($event)
          }
        }
      })
    }), 1) : (acc.products != null) ? _c('tbody', [_c('td', {
      staticClass: "ui center aligned",
      attrs: {
        "colspan": "6"
      }
    }, [_vm._v("Could not detect any products with recent sale")])]) : _c('tbody', [_vm._m(4, true), _vm._v(" "), _c('td', [_vm._v("Image")])])])])
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loadingdata && !_vm.loadError),
      expression: "!loadingdata && !loadError"
    }],
    staticClass: "ui attached message"
  }, [_c('div', {
    staticClass: "ui grid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "ten wide column"
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "16px"
    }
  }, [_vm._v(_vm._s(_vm.activeCount) + " tracked listings"), (_vm.activeCount != _vm.originalActiveCount) ? _c('span', [_vm._v(" (*)")]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.automaticallyTrackNewProducts),
      expression: "automaticallyTrackNewProducts"
    }],
    staticClass: "ui right pointing blue basic label",
    staticStyle: {
      "background-color": "#fff !important"
    }
  }, [_vm._v("Important")]), _vm._v(" "), _c('div', {
    staticClass: "ui checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.automaticallyTrackNewProducts),
      expression: "automaticallyTrackNewProducts"
    }],
    attrs: {
      "type": "checkbox",
      "data-lpignore": "true",
      "name": "automaticallyTrackNewProducts"
    },
    domProps: {
      "checked": Array.isArray(_vm.automaticallyTrackNewProducts) ? _vm._i(_vm.automaticallyTrackNewProducts, null) > -1 : (_vm.automaticallyTrackNewProducts)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.automaticallyTrackNewProducts,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.automaticallyTrackNewProducts = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.automaticallyTrackNewProducts = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.automaticallyTrackNewProducts = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Automatically track new products upon first sale")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.automaticallyTrackNewProducts),
      expression: "!automaticallyTrackNewProducts"
    }],
    staticClass: "ui left pointing orange label"
  }, [_c('span', {
    attrs: {
      "data-inverted": "",
      "data-tooltip": "Keep this ON, especially for new accounts",
      "data-position": "top right"
    }
  }, [_vm._v("\n            Recommended setting: ON\n            ")])])]), _vm._v(" "), (_vm.maxPage > 0) ? _c('div', {
    staticClass: "six wide column"
  }, [(_vm.maxPage > 0) ? _c('pagination', {
    attrs: {
      "currentPage": _vm.currentPage,
      "maxPage": _vm.maxPage,
      "currentPageRequested": _vm.currentPageRequested
    },
    on: {
      "back-to-1": function($event) {
        _vm.currentPageRequested = 0
      },
      "back": function($event) {
        _vm.currentPageRequested = Math.max(0, _vm.currentPage - 1)
      },
      "forward": function($event) {
        _vm.currentPageRequested = Math.min(_vm.maxPage, _vm.currentPage + 1)
      },
      "forward-all-the-way": function($event) {
        _vm.currentPageRequested = _vm.maxPage
      }
    }
  }) : _vm._e()], 1) : _vm._e()])])]), _vm._v(" "), _c('br', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loadingdata && !_vm.loadError),
      expression: "!loadingdata && !loadError"
    }]
  }), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loadingdata && !_vm.loadError),
      expression: "!loadingdata && !loadError"
    }],
    staticClass: "ui primary button",
    class: {
      'loading': _vm.savingdata
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Save")]), _vm._v(" "), (_vm.$root.anySellerAccountSetupCompleted) ? _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loadingdata && !_vm.loadError),
      expression: "!loadingdata && !loadError"
    }],
    staticClass: "ui button",
    on: {
      "click": function($event) {
        return _vm.$router.push(_vm.$root.defaultPath)
      }
    }
  }, [_vm._v("Cancel")]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loadingdata && !_vm.loadError),
      expression: "!loadingdata && !loadError"
    }],
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "data-inverted": "",
      "data-tooltip": "Bulk-edit your Product Settings in a spreadsheet",
      "data-position": "top center"
    }
  }, [_c('div', {
    staticClass: "ui right pointing purple label",
    staticStyle: {
      "margin-right": "20px"
    }
  }, [_vm._v("New")]), _vm._v(" "), _c('button', {
    staticClass: "ui labeled icon button",
    on: {
      "click": _vm.exportExcel
    }
  }, [_c('i', {
    staticClass: "download icon"
  }), _vm._v("Export\n    ")]), _vm._v(" "), _c('span', [_c('label', {
    staticClass: "ui labeled icon button",
    attrs: {
      "for": "hidden-product-import-file"
    },
    on: {
      "click": _vm.resetFiles
    }
  }, [_c('i', {
    staticClass: "upload icon"
  }), _vm._v("Import\n      ")]), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "id": "hidden-product-import-file"
    },
    on: {
      "change": _vm.importExcel
    }
  })])]), _vm._v(" "), _c('p', [_vm._v(" ")]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('p', [_vm._v(" ")]), _vm._v(" "), _c('p', [_vm._v(" ")]), _vm._v(" "), _c('p', [_vm._v(" ")])], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "list"
  }, [_c('li', [_vm._v("Products that sold at least one unit in the last few weeks appear here.")]), _vm._v(" "), _c('li', [_vm._v("This list keeps updating automatically. Easy.")]), _vm._v(" "), _c('li', [_vm._v("\"Ignore\" products you are not interested in following. We preselected the ones seemingly not selling much.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "list"
  }, [_c('li', [_vm._v("Once we detect activity in a new marketplace it will appear here too.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui inverted dimmer"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "black text"
  }, [_vm._v("Syncing your account from Amazon, this may take a while..")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "center aligned"
  }, [_vm._v("   Ignore   ")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th', [_vm._v("Title / Short-Hand Name on SentryKit ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('i', {
    staticClass: "us flag"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui positive message"
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("\n      Pro Tip\n    ")]), _vm._v(" "), _c('ul', {
    staticClass: "list"
  }, [_c('li', [_vm._v("It is a good idea to set a Short-Hand name for your products. This is how we display your products on SentryKit and all emails.")]), _vm._v(" "), _c('li', [_vm._v("We recommend doing this now but you can always come back here later. Check out the menu on top right corner.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3ad3d557!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ProductSettingsPage.vue
// module id = 753
// module chunks = 2